import { useEffect } from 'react'

import { authStatusHandler, userHandler } from 'shared/store'

import {
  getCurrUser,
  getNewAccessToken,
  redirectToLogin,
  redirectToNotAllowed,
} from '@api/auth.requests'
import { AuthStatus } from 'shared/types'

const allowedUsers = [
  '66a2489f9a6b27020c377e49',
  '66a2721f7c1b5cdeb08647c3',
  '66b9c1fbab1cb9eb1da948a3',
  '66b616ece5e252d5f6dfd952',
  '69410dd81157007bb065ae68',
  '696a18f85b338f4db0a9635a',
]

const allowedEmails = [
  's.dikov@onpoint.ru',
  'm.karchevskaya@onpoint.ru',
  'n.panitskova@onpoint.ru',
  'a.bobrovnikova@onpoint.ru',
]

const normalizeEmail = (value?: string) => (value || '').trim().toLowerCase()

const useInitialAuth = () => {
  useEffect(() => {
    const fetchData = async () => {
      const data = await getNewAccessToken()

      if (!data) return redirectToLogin()

      if (import.meta.env.MODE === 'debug') {
        const userId = data.data.user._id
        const userEmail = normalizeEmail(data.data.user.email)
        const isAllowedById = allowedUsers.includes(userId)
        const isAllowedByEmail = allowedEmails.some((email) => normalizeEmail(email) === userEmail)
        const isAllowed = isAllowedById || isAllowedByEmail

        if (!isAllowed) {
          redirectToNotAllowed()
          return
        }
      }

      const currUser = await getCurrUser()
      userHandler(currUser)
      authStatusHandler(AuthStatus.AUTHORIZED)
    }

    fetchData()
  }, [])
}

export default useInitialAuth
